import React, { useState } from "react";
import ModalSkeleton from "../../stories/ModalSkeleton/ModalSkeleton";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./ForgotPassModal.module.css";
import MailIcon from "@mui/icons-material/Mail";
import LockIcon from "@mui/icons-material/Lock";
import Button from "../../stories/Button/Button";
import Input from "../../stories/Input";
import { apiHeader, BaseURL, validateEmail } from "../../config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";

const ForgotPassModal = ({ show, setShow }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // handleForgotPass
  const handleForgotPass = async () => {
    if (!validateEmail(email))
      return toast.warn("Please enter a valid email address.");

    const url = BaseURL("users/forgotPassword");

    const params = {
      email,
    };

    setIsLoading(true);
    const response = await Post(url, params, apiHeader());
    setIsLoading(false);

    if (response !== undefined) {
      toast.success(
        "A link has been sent on your email address to reset your password."
      );
      setShow(false);
    }
  };

  return (
    <ModalSkeleton
      modalWidth={"28%"}
      modalPadding={"60px"}
      show={show}
      setShow={setShow}
    >
      <Container>
        <Row className={classes.input_mar}>
          <div className={"text-center"}>
            <h3>Forgot Password</h3>
            <p style={{ color: "#929292" }}>Please Enter Your Email</p>
          </div>
          <Col md={12}>
            <label>Email</label>

            <Input
              className={classes.cus_input}
              leftIcon={<MailIcon />}
              placeholder={"johndenly@info.com"}
              type={"email"}
              value={email}
              setter={setEmail}
            />
          </Col>

          <div className={classes.lgn_btn_div}>
            <Button primary onClick={handleForgotPass} disabled={isLoading}>
              {isLoading ? "Sending..." : "Send"}
            </Button>
          </div>
        </Row>
      </Container>
    </ModalSkeleton>
  );
};

export default ForgotPassModal;
